module.exports = __webpack_public_path__ + "static/media/hand-plant.d9fd771d.png";